import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

const mockMarketData = [
  { symbol: 'BTC/USD', price: '$64,230.50', change: '+2.4%', up: true },
  { symbol: 'XAU/USD (Gold)', price: '$2,345.10', change: '+1.2%', up: true },
  { symbol: 'EUR/USD', price: '$1.08', change: '-0.1%', up: false },
  { symbol: 'WTI Crude (Oil)', price: '$82.40', change: '+0.8%', up: true },
  { symbol: 'ETH/USD', price: '$3,450.20', change: '+1.8%', up: true },
  { symbol: 'Cocoa Futures', price: '$9,850', change: '+4.5%', up: true },
  { symbol: 'XAG/USD (Silver)', price: '$28.30', change: '-0.5%', up: false },
  { symbol: 'Private Credit Index', price: '112.4', change: '+0.2%', up: true },
];

const CryptoMarquee = () => {
  // Duplicate array to create seamless loop
  const tickerItems = [...mockMarketData, ...mockMarketData, ...mockMarketData];

  return (
    <div style={{
      width: '100%',
      background: 'var(--bg-modal)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid var(--border-color)',
      borderBottom: '1px solid var(--border-color)',
      padding: '0.75rem 0',
      overflow: 'hidden',
      display: 'flex',
      whiteSpace: 'nowrap',
      position: 'relative',
      zIndex: 10
    }}>
      <motion.div
        animate={{ x: [0, -1035] }} // Adjust depending on content width
        transition={{ 
          ease: "linear", 
          duration: 20, 
          repeat: Infinity 
        }}
        style={{ display: 'flex', gap: '3rem' }}
      >
        {tickerItems.map((coin, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontWeight: '600' }}>
            <span style={{ color: 'var(--text-secondary)' }}>{coin.symbol}</span>
            <span style={{ color: 'var(--text-primary)' }}>{coin.price}</span>
            <span style={{ 
              display: 'flex', alignItems: 'center', fontSize: '0.9rem',
              color: coin.up ? 'var(--success)' : 'var(--danger)',
              background: coin.up ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)',
              padding: '0.2rem 0.4rem', borderRadius: '4px'
            }}>
              {coin.up ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
              {coin.change}
            </span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default CryptoMarquee;
